export const PORTFOLIO_ID_PARAM = 'portfolioId';

export const getPortfolioIdFromUrl = () => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(PORTFOLIO_ID_PARAM);
};
